const NotFoundPage = () => {
	return (
		<div className="global-error">
			<div>
				<h1>404 - Page Not Found</h1>
				<p>Sorry, the page you are looking for does not exist.</p>
			</div>
		</div>
	);
};

export default NotFoundPage;
